import { createSlice } from "@reduxjs/toolkit";

export interface CustomerAuthResponse {
  access_token: string;
  token_type: string;
  client: {
    id: number;
    country_code: string;
    phone_number: string;
    email: string;
    first_name: string;
    last_name: string;
    company_id: number | null;
    assigned_user_id: number | null;
    created_by_id: number | null;
    updated_by_id: number | null;
    is_active: boolean;
    created_at: string;
    updated_at: string;
  };
}

export type AuthState = {
  user: any | null;
  session: any | null;
  otpAccessToken: string | null;
  customerAuth: CustomerAuthResponse | null;
  isOtpAuthenticated: boolean;
  lastAuthenticatedAt: string | null;
};

const initialState: AuthState = {
  user: null,
  session: null,
  customerAuth: null,
  otpAccessToken: null,
  isOtpAuthenticated: false,
  lastAuthenticatedAt: null,
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    userData: (state, action: { payload: AuthState["user"] }) => {
      state.user = action.payload;
    },
    setSession(state, action: { payload: AuthState["session"] }) {
      state.session = action.payload;
    },
    setOtpAccessToken(state, action: { payload: string | null }) {
      state.otpAccessToken = action.payload;
    },
    setCustomerAuth(state, action: { payload: CustomerAuthResponse }) {
      state.customerAuth = action.payload;
    },
    setRetailAuth(
      state,
      action: {
        payload: {
          session: AuthState["session"];
          accessToken?: string | null;
        };
      }
    ) {
      state.session = action.payload.session;
      state.otpAccessToken = action.payload.accessToken ?? state.otpAccessToken;
      state.isOtpAuthenticated = true;
      state.lastAuthenticatedAt = new Date().toISOString();
    },
    clearRetailAuth(state) {
      state.session = null;
      state.otpAccessToken = null;
      state.isOtpAuthenticated = false;
      state.lastAuthenticatedAt = null;
    },
    logout(state) {
      state.user = null;
      state.session = null;
      state.otpAccessToken = null;
      state.customerAuth = null;
      state.isOtpAuthenticated = false;
      state.lastAuthenticatedAt = null;
      localStorage.removeItem("persistentPersonal");
      localStorage.removeItem("persistentTravel");
      localStorage.removeItem("resumeSessionData");
      localStorage.removeItem("coverageApiData");
      localStorage.removeItem("travel_step2_details");
      localStorage.removeItem("travel_step1_details");
      localStorage.removeItem("coverageOptionsWithIds");
    },
  },
});

export const {
  userData,
  setSession,
  setOtpAccessToken,
  setRetailAuth,
  clearRetailAuth,
  logout,
  setCustomerAuth,
} = authSlice.actions;
export default authSlice.reducer;
